<app-navbar-primary />

<main class="bg-body-secondary">
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="card overflow-auto" style="width: 34rem; height: 34rem">
      <div class="card-body">
        <button class="btn p-0 mb-3" routerLink="/">
          <img src="/assets/icons/arrow_left_short.svg" alt="" />
          <span class="text-body-secondary">Volver</span>
        </button>

        <h4>Documentos de Referencia</h4>

        <div class="d-flex flex-column mt-4">
          <div>
            <button
              #btn
              class="btn btn-outline-primary mt-2 mb-1"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-expanded="false"
              aria-controls="collapse1"
              (click)="buttonCollapsed[0] = !buttonCollapsed[0]"
            >
              <i
                class="bi"
                [class]="
                  buttonCollapsed[0] ? 'bi-chevron-down' : 'bi-chevron-up'
                "
              ></i>
              Consultar documentos
            </button>
          </div>

          <div class="collapse" id="collapse1">
            <div class="list-group">
              @if (loading) {
                <div class="text-center py-3">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                </div>
              } @else if (error) {
                <div class="text-body-secondary py-2">
                  No se pudieron cargar los documentos. Intenta más tarde.
                </div>
              }
              @for (file of files; track file.id) {
                <a
                  class="list-group-item list-group-item-action"
                  [href]="file.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ file.name }}
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer-primary />
